<template>
  <div :class="['slider-container', `${ theme }-style`, 'scroll-x', activeDirectionClass]"
       v-if="!$isMobile"
       @mouseleave="focusFalse">
    <card-slider v-for="(item, index) in infoCards"
                 :class="className || 'card-slider-container'"
                 @changeId="changeId(item.id)"
                 @actionClick="$emit('actionClick', item)"
                 @mouseenter="focusTrue(item.id)"
                 :theme="theme"
                 :key="index"
                 :item="item"
                 :id-active-card="idActiveCard"
                 :id-focus-param="idFocusParam">
      <template v-slot:bottom-block>
        <slot name="cardItem" :item="item"/>
      </template>
    </card-slider>
    <div class="active-line-container"
         :style="{
          left: activeTransform,
          width: `${ blockWidth }px`
      }">
    </div>
  </div>
  <div :class="['slider-container', 'slider-container-static' , activeDirectionClass]"
       v-else-if="isActiveStatic"
       @mouseleave="focusFalse">
    <card-slider v-for="(item, index) in infoCards"
                 :class="className || 'card-slider-container'"
                 @changeId="changeId(item.id)"
                 @actionClick="$emit('actionClick', item)"
                 @mouseenter="focusTrue(item.id)"
                 :theme="theme"
                 :key="index"
                 :item="item"
                 :id-active-card="idActiveCard"
                 :id-focus-param="idFocusParam">
      <template v-slot:top-block>
        <div class="active-line-container"
             :style="{
            width: `${ idActiveCard === item.id ? '100%' : 0 }`
        }"/>
      </template>
      <template v-slot:bottom-block>
        <slot name="cardItem" :item="item"/>
      </template>
    </card-slider>
  </div>
  <slider-banner :class="['slider-container', `${ theme }-style`, activeDirectionClass]"
                 :class-name="className"
                 :is-active-static-last-slide="isActiveStaticLastSlide"
                 :id-out="idActiveCard"
                 :is-change-out="!isActiveFocus"
                 :is-active-padding="false"
                 v-else
                 @changeId="changeId"
                 :cards-info="infoCards">
    <template v-slot:card="{ item }">
      <card-slider @changeId="changeId(item.id)"
                   @actionClick="$emit('actionClick', item)"
                   :theme="theme"
                   :key="item.id"
                   :item="item"
                   :id-active-card="idActiveCard"
                   :id-focus-param="idFocusParam">
        <template v-slot:bottom-block>
          <slot name="cardItem" :item="item"/>
        </template>
      </card-slider>
    </template>
    <template v-slot:another-content>
      <div class="active-line-container"
           :style="{
          left: activeTransform,
          'min-width': `${ blockWidth }px`,
          'max-width': `${ blockWidth }px`
      }">
      </div>
    </template>
  </slider-banner>
</template>

<script>
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import CardSlider from "@/components/entities/cards/CardSlider.vue";
import SliderBanner from "@/components/entities/SliderBanner.vue";

export default {
  name: "BlockSlider",
  components: {SliderBanner, CardSlider, MainParagraph},
  props: {
    isActiveStaticLastSlide: {
      type: Boolean,
      default: false
    },
    isActiveStatic: {
      type: Boolean,
      default: false
    },
    activeDirectionClass: {
      type: String,
      default: 'default-direction'
    },
    className: {
      type: String,
      default: 'card-wrapper'
    },
    idOut: {
      type: Number
    },
    isActiveOut: {
      type: Boolean,
      default: false
    },
    infoCards: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      default: 'default'
    },
    isActiveFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      idActiveCard: 0,
      idFocusParam: false,
      blockWidth: 0,
      timer: null
    }
  },
  computed: {
    activeTransform() {
      let activeIndex = this.idFocusParam !== false
          ? this.idFocusParam
          : this.idActiveCard
      let isLastActive = this.idActiveCard === this.infoCards[this.infoCards.length - 1]?.id
      return `${ !this.$isMobile ? (activeIndex * this.blockWidth)
          : this.isActiveStaticLastSlide && isLastActive
              ? this.blockWidth
              : 0
      }px`
    }
  },
  watch: {
    idOut() {
      this.checkId();
    }
  },
  mounted() {
    this.checkSizeCard();
    this.checkId();
    addEventListener('resize', this.checkSizeCard)
  },
  unmounted() {
    removeEventListener('resize', this.checkSizeCard)
  },
  methods: {
    checkId() {
      if(this.idOut !== this.idActiveCard && this.isActiveOut) {
        this.idActiveCard = this.idOut
      }
    },
    checkSizeCard() {
      let className = this.className
          ? `.${this.className}`
          : '.card-slider-container'
      this.blockWidth = document.querySelector(className)?.clientWidth || 210
    },
    changeId(id) {
      if(this.isActiveFocus) {
        this.idActiveCard = id;
        this.$emit('changeId', id)
      }
    },
    focusTrue(id) {
      if(this.isActiveFocus && !this.$isMobile) {
        this.checkSizeCard();
        this.idFocusParam = id;
        this.$emit('changeId', id)
      }
    },
    focusFalse() {
      if(this.isActiveFocus && !this.$isMobile) {
        this.idFocusParam = false;
        this.$emit('changeId', this.idActiveCard)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.slider-container {
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
  &.slider-container-static {
    display: flex;
    flex-direction: column;
    row-gap: 24px;

    .card-slider-container {
      width: 100%;
      min-width: 100%;
      max-width: 100%;

      ::v-deep(.active-line-container) {
        top: 0;
        left: 0;
      }
    }
  }
  &.center-info-container {
    .card-slider-container {
      width: 100%;
      ::v-deep(.main-title-container) {
        justify-content: center;
        text-align: center;
        color: var(--color-purple);
      }
    }
  }

  &.dark-style {
    .active-line-container {
      background-color: var(--color-violet);
    }
  }
}

.active-line-container {
  z-index: 1;
  content: '';
  background-color: var(--color-orange);
  position: absolute;
  top: 0;
  transition: all .6s;
}
@media (max-width: 3024px){
  .slider-container {
    padding-bottom: 18px;
  }
  .active-line-container {
    height: 3px;
  }
}


@media (max-width: 1920px) {
  .slider-container {
    padding-bottom: 16px;
  }

  .active-line-container {
    height: 3px;
  }

}
@media (max-width: 1600px) {
  .slider-container {
    padding-bottom: 16px;
  }

  .active-line-container {
    height: 3px;
  }
}
@media (max-height: 800px) {
  .slider-container {
    padding-bottom: 12px;
  }

  .active-line-container {
    height: 2px;
  }
}

@media (max-width: 1400px) and (min-height: 801px) {

  .slider-container {
    padding-bottom: 16px;
  }

  .active-line-container {
    height: 3px;
  }

}

@media (max-width: 1133px) {
  .slider-container {
    padding-bottom: 12px;
  }

  .active-line-container {
    height: 2px;
  }
}
@media (max-width: 769px) {
  .slider-container {
    margin-top: 20px;
    overflow: visible;
    padding-bottom: 0;
  }

  .active-line-container {
    height: 2px;
  }
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .slider-container {
    padding-bottom: 24px;
  }

  .active-line-container {
    height: 8px;
  }
}

</style>